import {
  format,
  newDate,
  isEqual,
  parse,
  differenceInDays,
  getYear,
  getMonth,
  getDate,
  startOfDay,
} from "date-fns-jalali";
import { format as gregorianFormat } from "date-fns";

/**
 * Converts a Jalali date string to a Gregorian date formatted as yyyy-MM-dd
 * @param jalaliDate - Jalali date string in YYYY/MM/DD or YYYY-MM-DD format
 * @returns Gregorian date string in yyyy-MM-dd format
 * @throws Error if the input format is invalid
 */
export function jalaliToGregorian(jalaliDate: string): string {
  try {
    const normalizedDate = jalaliDate.replace(/\//g, "-");

    const date: Date = parse(normalizedDate, "yyyy-MM-dd", new Date());

    const gregorianDate: string = gregorianFormat(date, "yyyy-MM-dd");

    if (!/^\d{4}-\d{2}-\d{2}$/.test(gregorianDate)) {
      throw new Error("Invalid date conversion");
    }

    return gregorianDate;
  } catch (error) {
    throw new Error("Invalid Jalali date format. Use YYYY/MM/DD or YYYY-MM-DD");
  }
}

export const formatIntoJalaliFunc = (value: Date | string | unknown) =>
  format(value as string, "yyyy/MM/dd");

export const isEqualDate = (value: Date | string | unknown) =>
  format(value as string, "yyyy/MM/dd");

export function getCurrentDate(selectedDate: string) {
  const d1 = new Date();
  const d2 = new Date(selectedDate);

  const todayGregorian = new Date(
    d1.getFullYear(),
    d1.getMonth(),
    d1.getDate(),
  );
  const activeDate = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate());

  return isEqual(todayGregorian, activeDate);
}

export const generateDays = (year: number, month: number) => {
  const daysInMonth = 31;
  // const daysInMonth = getDaysInMonth(new Date(year, month - 1));
  return Array.from({ length: daysInMonth }, (_, i) => i + 1);
};

export const generateMonths = () => {
  return Array.from({ length: 12 }, (_, i) => i + 1);
};

export const generateYears = (startYear: number, endYear: number) => {
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.unshift(year);
  }
  return years;
};

export function formatDateWithInitial(date: string) {
  const formattedDate = format(date, "EEEE - M/d");

  const parts = formattedDate.split(" - ");
  const weekday = parts[0];
  const initial = weekday.charAt(0);

  const finalFormattedDate = `${initial} - ${parts[1]}`;

  return finalFormattedDate;
}

export function getTimeOfDay(hour: number) {
  if (hour >= 6 && hour < 12) return "morning";
  if (hour >= 12 && hour < 18) return "afternoon";
  if (hour >= 18 && hour < 24) return "evening";
  return "night";
}

export function militaryTimeToDate(time: string) {
  const [hours, minutes] = time.split(":");

  const date = new Date();
  date.setHours(Number.parseInt(hours, 10), Number.parseInt(minutes, 10), 0, 0);

  return date;
}

/**
 *
 * @param checkIn - checkin date
 * @param checkOut - checkout date
 * @returns returns the difference in days between checkIn and checkOut
 */

export function calculateStayNightDuration(checkIn: string, checkOut: string) {
  const startDate = parse(checkIn ?? "", "yyyy-MM-dd", new Date());
  const endDate = parse(checkOut ?? "", "yyyy-MM-dd", new Date());

  return differenceInDays(endDate, startDate);
}

export function formatTimeToPersian(timeString: string): string {
  const [hour, minute] = timeString.split(":");

  const hourTitle = `${hour} ساعت`;
  const minuteTitle = `${minute} دقیقه`;

  return `${hourTitle} ${minute !== "0" ? `و ${minuteTitle}` : ""}`;
}
